module.exports = __webpack_public_path__ + "static/media/car.1fb3fd28.gif";